import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { LiveGenreIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"

export const LiveGenreDocumentMeta = z.object({
  label: z.string().describe("ジャンル名。この値をユーザーに露出する").min(1).max(15),
  available: z.boolean().describe("これがtrueの場合は新規に設定可能"),
  priority: z.int().describe("優先度")
})

export type LiveGenreDocumentMeta = z.infer<typeof LiveGenreDocumentMeta>

export const LiveGenreDocumentBody = z.intersection(
  LiveGenreDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type LiveGenreDocumentBody = z.infer<typeof LiveGenreDocumentBody>

export const LiveGenreDocument = z.intersection(
  LiveGenreDocumentBody,
  z.object({
    id: LiveGenreIdSchema,
  })
)
export type LiveGenreDocument = z.infer<typeof LiveGenreDocument>

export class LiveGenreDocuments {
  static toDocumentData(genre: LiveGenreDocument): object {
    return {
      ...genre,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): LiveGenreDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: LiveGenreIdSchema.parse(doc.id),
      label: data["label"],
      available: data["available"],
      priority: data["priority"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const CreateOrUpdateLiveGenreDocumentRequest = z.object({
  label: z.string().trim().min(1).max(15),
  available: z.boolean(),
  priority: z.int(),
})

export type CreateOrUpdateLiveGenreDocumentRequest = z.infer<typeof CreateOrUpdateLiveGenreDocumentRequest>

export const BulkUpdateLiveGenrePrioritiesRequest = z.object({
  genres: z.array(
    z.object({
      id: LiveGenreIdSchema,
      priority: z.int(),
    })
  ),
})

export type BulkUpdateLiveGenrePrioritiesRequest = z.infer<typeof BulkUpdateLiveGenrePrioritiesRequest>
